import axios from "axios";
import { Base_URL } from "../url";

export const saveAdvanceRequest = async (advanceData) => {
  try {
    const response = await axios.post(`${Base_URL}/AdvanceReq/AdvanceCash`, advanceData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save advance request";
  }
};